<div class="mb-1">
    <p-menubar [model]="categoryMenuItems" />
</div>